import React, { useState } from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function RegularSelect(
  props: {
    form: any;
    name: string;
    label?: string;
    items: any;
    extraClass?: string;
    isDisabled?: boolean;
    bg?: any;
    placeholder?: string,
  },
  { bg }: any
) {
  const extraClass = props.extraClass || "";
  const isDisabled = props.isDisabled || false;

  return (
    <FormField
      control={props.form.control}
      name={props.name}
      render={({ field }) => (
        <FormItem className="mt-4">
          <FormLabel className="font-semibold flex items-center">
            {props.label}
          </FormLabel>
          <FormControl >
            <Select onValueChange={field.onChange} value={field.value} >
              <SelectTrigger
                className={
                  isDisabled
                    ? `w-full ${extraClass} bg-slate-200 disabled:opacity-100`
                    : `w-full ${extraClass}`
                }
                disabled={isDisabled}
              >
                <SelectValue placeholder={props.placeholder} />
              </SelectTrigger>
              <SelectContent>
                {props.items.map((item: any) => {
                  return (
                    <SelectItem
                      key={item.value}
                      value={item.value}
                      bg={props.bg}
                    >
                      {item.label}
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
